module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/external-dark-ca0587e570f3d07c92d5b23d7824b274.svg";